import React from 'react';

/**
 * Circular progress ring rendered with SVG. No external deps.
 */
export default function ConsensusRing({ score = 0, size = 140, stroke = 12, label = 'Consensus' }) {
    const v = Math.max(0, Math.min(100, score));
    const r = (size - stroke) / 2;
    const c = 2 * Math.PI * r;
    const offset = c - (v / 100) * c;
    return (
        <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
            <svg width={size} height={size} className="-rotate-90">
                <circle
                    cx={size / 2} cy={size / 2} r={r}
                    fill="none" strokeWidth={stroke}
                    stroke="var(--ns-soft)"
                />
                <circle
                    cx={size / 2} cy={size / 2} r={r}
                    fill="none" strokeWidth={stroke}
                    stroke="var(--ns-clay)"
                    strokeLinecap="round"
                    strokeDasharray={c}
                    strokeDashoffset={offset}
                    style={{ transition: 'stroke-dashoffset 0.8s ease-out' }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-[var(--ns-text)]">{v}<span className="text-base align-top">%</span></div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-[var(--ns-text3)] mt-0.5">{label}</div>
            </div>
        </div>
    );
}
